<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only" >
  <v-select
    v-model="model"
    :prepend-icon="prepend_icon"
    :append-icon="append_icon"
    :item-text="item_key"
    :item-value="c_value_key"
    clearable
    menu-props="auto"
    :label="label"
    @change="change"
    :return-object="return_object"
    :items="items"
    />
  </pre_input>
</template>
<script>
import filter_rq from './filter_rq';
import pre_input_js from '@/components/mixins/pre_input';
export default {
  props:{
    f_key:{},
    multiple:{default:false},
    items:{default:() => []},
  },
  mixins: [ filter_rq,pre_input_js ],
  data(){
    return {
      model: null,
      reset_on_value_change:true,
      filter_rq_type:['>'],
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
    c_value_key() {return this.value_key || this.item_key},
    string_items(){
      const l = this.items.map(m=>{ return typeof m == 'object'? {...m}:m});
      return l.map((m,i) => this.c_value_key?((m[this.c_value_key] = m[this.c_value_key]+'') && m):m+'')
    },
  },
  watch: {
    'search'(v,v_old){ this.set_model() },
  },
  methods: {
    set_model() {
      let val;
      const ex_f = {};
      if (this.return_object){
        ex_f[this.k_f] = this.value[this.c_value_key];
        /*  con value como id buscar en la lista y asignar a model*/
        const value = this.multiple
          ? (this.value||[]).map(m=>m[this.c_value_key])
          : (this.value||{})[this.c_value_key];
        val = this.multiple
          ? this.items.filter(f => value.includes(f[this.c_value_key]))
          : this.items.find(f => value === this.value) || null;
      } else {
        if (this.c_value_key) {
          ex_f[this.k_f] = this.value;
          val = this.multiple
            ? this.items.filter(i => this.value.includes(i[this.c_value_key]))
            : this.items.find(i => i[this.c_value_key] === this.value);
        } else {
          ex_f[this.k_f] = this.value;
          val = this.value
        }
        
      }
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f)
        .then(r => {
          this.model = val;
          return r
        });
    },
    upd(){
      this.$emit('update:value', this.model);
    },
    /* los elementos retornados no afectan las opciones de este filtro */
    then_get_rows(r) { return r },
  },
};
</script>
